<template>
    <div class="page container">
        
        <div class="pure-g contentArea">

            <div class="pure-u-1 pure-u-lg-18-24 left">
                <p class="sectionTitle">Joined Events 
                    <router-link to="events" class="linkBtn">View All <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                </p>
                <Events 
                    grid="3"
                    type="userJoined"
                ></Events>
                <div class="center viewMoreArea">
                    <router-link to="events" class="linkBtn center">View All Events <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                </div>
            </div>

            <div class="pure-u-1 pure-u-lg-6-24 right">
                <Banner></Banner>
            </div>

        </div>

    </div>
</template>

<script>
    import Events from '../../components/Events.vue'
    import Banner from '../../components/Banner.vue'

    export default {
        components: {
            Events,
            Banner
        },
        mounted: function(){
            if(!this.isMember){
                this.$router.push('/welcome1')
            }
        },
        computed: {
            currentUser(){
                return this.$store.state.currentUser
            },
            userProfile(){
                return this.$store.state.userProfile
            },
            isMember(){
                return this.$store.state.isMember
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Account/Account.vue